export type Width = 'small' | 'medium' | 'large' | 'xlarge'

export const widths = {
  small: 1080,
  medium: 1362,
  large: 1640,
  xlarge: 1920,
}
